import React from 'react';
import { ArticleBlockContentGridCol } from '../components/ArticleBlockContentGridCol/ArticleBlockContentGridCol';
import { BlockContentContext } from '../../BlockContent.utils';
import { VehicleInspectionSerializerProps } from '../components/VehicleInspection/VehicleInspection.types';
import { VehicleInspectionBlock } from '../components/VehicleInspection/VehicleInspection';

export const VehicleInspectionSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article || context === BlockContentContext.ProductArticle) {
    return ({ value }: VehicleInspectionSerializerProps) => (
      <ArticleBlockContentGridCol $width="full">
        <VehicleInspectionBlock contexts={value?.contexts} />
      </ArticleBlockContentGridCol>
    );
  }
  return ({ value }: VehicleInspectionSerializerProps) => <VehicleInspectionBlock contexts={value?.contexts} />;
};
